// extracted by mini-css-extract-plugin
export default {"crumb":"BreadCrumb_crumb__q6L-8","link":"BreadCrumb_link__ZJxWb"};